<template>
  <v-navigation-drawer
    right
    app
    fixed
    temporary
    permanent
    width="40vw"
    height="93vh"
    style="top: 65px"
  >
    <v-row>
      <v-col cols="12" sm="1">
        <v-icon @click="closePanel()" class="mx-2">mdi-close</v-icon>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click="goTo()">mdi-arrow-top-right</v-icon>
          </template>
          <span> Go To </span>
        </v-tooltip>
      </v-col>
    </v-row>
    <component
      :is="activeComponent"
      :viewOnly="true"
      :schoolId="schoolId"
      :clientId="clientId"
      :districtAdminId="districtAdminId"
      :providerId="providerId"
    />
  </v-navigation-drawer>
</template>

<script>
import SchoolForm from "../Client/Schools/school-form.vue";
import ClientDetails from "../Client/Details/client-details.vue";
import DistrictAdminForm from "../Client/DistrictAdmins/district-admin-form.vue";
import ProviderForm from "../Providers/provider-form.vue";

export default {
  props: [
    "schoolId",
    "clientId",
    "districtAdminId",
    "providerId",
    "activeComponent",
  ],
  components: {
    SchoolForm,
    ClientDetails,
    DistrictAdminForm,
    ProviderForm,
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    goTo() {
      this.$router.push({
        name: this.activeComponent,
        params: {
          clientId: this.clientId,
          schoolId: this.schoolId,
          districtAdminId: this.districtAdminId,
          providerId: this.providerId,
        },
      });
    },
  },
};
</script>
